import { render, staticRenderFns } from "./marketingComponents.vue?vue&type=template&id=65a2416f&scoped=true&lang=pug&"
import script from "./marketingComponents.vue?vue&type=script&lang=js&"
export * from "./marketingComponents.vue?vue&type=script&lang=js&"
import style0 from "./marketingComponents.vue?vue&type=style&index=0&id=65a2416f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2416f",
  null
  
)

export default component.exports